/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable no-loop-func */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { Form } from '@unform/web';
import Swal from 'sweetalert2';
import { cpf } from 'cpf-cnpj-validator';

import { useHistory, useParams } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { Container } from './styles';
import { KrUserDocument } from '~/components/KoroIcons';
import ButtonBack from '~/components/ButtonBack';
import { useAuth } from '~/hooks/Auth';
import { IItem, useCart } from '~/hooks/Cart';
import api from '~/services/api';
import getValidationErros from '~/utils/getValidationsErrors';
import Ticket, { IAnswer, IQuestionResponse } from './Ticket';
import Loading from '~/components/Loading';
import ButtonHome from '~/components/ButtonHome';
import formatDate from '~/utils/formatDate';

export interface ISize {
  id: number;
  value: string;
  selected: boolean;
  notSelectable?: boolean;
  quantity_expected?: number;
  quantity_used?: number;
}

export interface ITicket {
  gender?: string;
  birthdate?: string;
  showMyTicket?: boolean;
  myTicket?: boolean;
  index: number;
  item: IItem;
  document?: string;
  name?: string;
  phone?: string;
  email?: string;
  answers?: IAnswer[];
  sizes?: ISize[];
  hasKit?: boolean;
}

interface IParams {
  slug: string;
}

interface IFormData {
  document: string;
  name: string;
  birthdate: string;
  gender: string;
  phone: string;
  email: string;
  documents: string;
  color: string;
  size: string;
}

interface IQuantities {
  quantity_used: number;
  quantity_expected: number;
  id: number;
  size: string;
}

interface IArchiveEvent {
  archive: {
    archive_url: string;
  };
}

interface IEventResponse {
  id: number;
  date: string;
  unique_ticket: boolean;
  archivesEvents: IArchiveEvent[];
  kit2: {
    id: number;
    has_size_variation: boolean;
    stock_control: boolean;
    quantities: IQuantities[];
  };
}

interface ICheckTicket {
  batch_category_id: number;
  modality_id: number;
  event: {
    unique_ticket: boolean;
  };
  batchCategory: {
    category_id: number;
    modality_id: number;
  };
}

interface IParams {
  slug: string;
  preview: string;
}

const CheckoutOwnership: React.FC = () => {
  const { user } = useAuth();
  const { cart, handleChangeItems } = useCart();
  const formRef = useRef<FormHandles>(null);
  const history = useHistory();
  const params = useParams<IParams>();
  const [indexSel, setIndexSel] = useState<number>(-1);
  const [kitId, setKitId] = useState<number | undefined>(undefined);
  const [kitStockControl, setKitStockControl] = useState(false);
  const [hasSizeVariation, setHasSizeVariation] = useState(false);
  const [tickets, setTickets] = useState<ITicket[]>([]);
  const [eventId, setEventId] = useState<number | undefined>();
  const [sending, setSending] = useState(false);
  const [isUniqueTicket, setIsUniqueTicket] = useState(false);
  const [, setTicketError] = useState('');
  const [ticketErrors, setTicketErrors] = useState<Record<number, string>>({});
  const [sizes, setSizes] = useState<ISize[]>([]);
  const [sizesLoaded, setSizesLoaded] = useState(true);
  const [selectedSizeIds, setSelectedSizeIds] = useState<
    (number | undefined)[]
  >([]);
  const [banner, setBanner] = useState('');
  const [eventDate, setEventDate] = useState('');

  const isPreview = useMemo(() => !!params.preview, [params.preview]);

  useEffect(() => {
    const eventData = localStorage.getItem('@Koro:event');
    if (eventData) {
      const parsedEvent = JSON.parse(eventData);
      if (parsedEvent.slug === params.slug) {
        if (parsedEvent.kit2) {
          if (parsedEvent.kit2.has_size_variation) {
            const sizesData = parsedEvent.kit2.quantities.map(
              (quantity: any) => ({
                id: quantity.id,
                value: quantity.size,
                selected: false,
                notSelectable: false,
                quantity_expected: quantity.quantity_expected,
                quantity_used: quantity.quantity_used,
              })
            );
            setSizes(sizesData);
          }

          setHasSizeVariation(parsedEvent.kit2.has_size_variation);
          setKitStockControl(parsedEvent.kit2.stock_control);
          setKitId(parsedEvent.kit2.id);
        }
        setEventId(parsedEvent.id);
        setIsUniqueTicket(parsedEvent.unique_ticket);
        setEventDate(parsedEvent.date);
        setBanner(parsedEvent.archivesEvents[0]?.archive.archive_url);
        setSizesLoaded(false);
      } else {
        history.push(`/eventos/${params.slug}`);
      }
    } else {
      history.push(`/eventos/${params.slug}`);
    }
  }, [history, params.slug]);

  useEffect(() => {
    if (!sizesLoaded) return;
    const data = cart.items.map<ITicket>((item, index) => {
      let [day, month, year]: (string | undefined)[] = [
        undefined,
        undefined,
        undefined,
      ];
      if (item.ticket?.birthdate) {
        [day, month, year] = item.ticket.birthdate.split('/');
      }
      const date =
        item.ticket?.birthdate && year
          ? `${year}-${month}-${day}`
          : item.ticket?.birthdate;

      return {
        index,
        item,
        showMyTicket: true,
        myTicket: item.ticket?.document === user.additionalInformation.document,
        document: item.ticket?.document,
        name: item.ticket?.name,
        phone: item.ticket?.phone,
        email: item.ticket?.email,
        sizes,
        birthdate: date ? formatDate(date, 'dd/MM/yyyy') : '',
        gender: item.ticket?.gender || '',
        hasKit: item.has_kit,
      };
    });

    setTickets(data);
    setIndexSel(data.findIndex((ticket) => ticket.myTicket));
  }, [cart.items, sizes, sizesLoaded, user.additionalInformation.document]);

  const handleChangeMyTicket = useCallback(
    (ticket) => {
      const newTickets = tickets.map((ticketData) => {
        if (ticketData.index === ticket.index) {
          let [day, month, year]: (string | undefined)[] = [
            undefined,
            undefined,
            undefined,
          ];
          if (ticketData?.birthdate) {
            [day, month, year] = ticketData.birthdate.split('/');
          }
          const date =
            ticketData?.birthdate && year
              ? `${year}-${month}-${day}`
              : ticketData?.birthdate;
          return {
            ...ticketData,
            myTicket: !ticketData.myTicket,
            document: !ticketData.myTicket
              ? user.additionalInformation.document
              : ticketData.document || '',
            name: !ticketData.myTicket ? user.name : ticketData.name || '',
            email: !ticketData.myTicket ? user.email : ticketData.email || '',
            phone: !ticketData.myTicket
              ? user.additionalInformation.phone || ticketData.phone
              : ticketData.phone || '',
            birthdate: !ticketData.myTicket
              ? user.additionalInformation.birthdate
                ? formatDate(user.additionalInformation.birthdate, 'dd/MM/yyyy')
                : ''
              : date && formatDate(date, 'dd/MM/yyyy'),
            gender: !ticketData.myTicket
              ? user.additionalInformation.gender
              : ticketData.gender,
          };
        }

        if (
          ticketData.item.batch_category_id === ticket.item.batch_category_id &&
          ticketData.item.modality_id === ticket.item.modality_id
        ) {
          return {
            ...ticketData,
            myTicket: false,
            showMyTicket: ticket.myTicket,
          };
        }

        return ticketData;
      });

      setTickets(newTickets);
    },
    [tickets, user]
  );

  const handleChangeTicket = useCallback(
    (ticket) => {
      const newTickets = tickets.slice();
      newTickets[ticket.index] = ticket;

      setTickets(newTickets);
    },
    [tickets]
  );

  const handleChangeSize = useCallback(
    (ticketIndex: number, sizeId: number) => {
      setSelectedSizeIds((prev) => {
        const updated = [...prev];
        updated[ticketIndex] = sizeId;
        return updated;
      });
    },
    []
  );

  const getSizesForTicket = useCallback(
    (ticketIndex: number): ISize[] => {
      return sizes.map((size) => {
        const countInOthers = selectedSizeIds.filter(
          (id, i) => i !== ticketIndex && id === size.id
        ).length;
        const remaining =
          (size.quantity_expected ?? Infinity) -
          (size.quantity_used ?? 0) -
          countInOthers;
        return {
          ...size,
          notSelectable:
            remaining <= 0 &&
            selectedSizeIds[ticketIndex] !== size.id &&
            kitStockControl,
        };
      });
    },
    [sizes, selectedSizeIds, kitStockControl]
  );

  const handleChangeAnswers = useCallback(
    (answers, ticketIndex) => {
      const newTickets = tickets.slice();
      newTickets[ticketIndex].answers = answers;
      setTickets(newTickets);
    },
    [tickets]
  );

  const handleSubmit = useCallback(
    async (data: IFormData) => {
      const calculateAge = (
        birthdateStr: string,
        referenceDateStr?: string
      ): number | null => {
        if (!birthdateStr) return null;
        const parts = birthdateStr.split('/');
        if (parts.length !== 3) return null;
        const [day, month, year] = parts;
        const birth = new Date(
          parseInt(year, 10),
          parseInt(month, 10) - 1,
          parseInt(day, 10)
        );
        if (Number.isNaN(birth.getTime())) return null;
        let ref: Date;
        if (referenceDateStr) {
          const d = new Date(referenceDateStr);
          if (Number.isNaN(d.getTime())) return null;
          ref = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        } else {
          ref = new Date();
        }
        let age = ref.getFullYear() - birth.getFullYear();
        const m = ref.getMonth() - birth.getMonth();
        if (m < 0 || (m === 0 && ref.getDate() < birth.getDate())) age -= 1;
        return age;
      };

      try {
        setSending(true);
        setTicketErrors({});
        formRef.current?.setErrors({});

        const responseQuestions = await api.get<IQuestionResponse[]>(
          `questions/events/${eventId}`
        );

        const schema = Yup.object().shape({
          ...cart.items.reduce((previous, item, index) => {
            return {
              ...previous,
              [`document_${index}`]: Yup.string()
                .nullable(true)
                .test('check_document', 'O documento é obrigatório', () => {
                  return !!data[`document_${index}` as keyof IFormData];
                })
                .test('cpf', 'CPF inválido', (value) =>
                  !value ? true : cpf.isValid(value as string)
                )
                .test(
                  'check-no-duplicate-documents',
                  'Este documento já foi usado para a mesma categoria e modalidade em outro pedido',
                  async (value, context) => {
                    if (!value) return true;

                    const response = await api.get<ICheckTicket[]>(
                      `tickets/events/${eventId}/${value}`
                    );

                    if (response.data.length === 0) return true;

                    const { unique_ticket } = response.data[0].event;

                    if (unique_ticket) {
                      return context.createError({
                        message: 'Este documento já foi usado neste evento',
                      });
                    }

                    const checkTicket = response.data.some(
                      (ticketData) =>
                        ticketData.batchCategory.modality_id ===
                          tickets[index].item.modality_id &&
                        ticketData.batchCategory.category_id ===
                          tickets[index].item.category_id
                    );

                    return checkTicket
                      ? context.createError({
                          message:
                            'Este documento já foi usado para a mesma categoria e modalidade em outro pedido',
                        })
                      : true;
                  }
                )
                .test(
                  'no-duplicate-documents',
                  'Documento repetido para a mesma categoria e modalidade',
                  (_, context) => {
                    if (!tickets) return true;

                    const currentDocument = context.parent[`document_${index}`];
                    const currentCategoryId =
                      cart.items[index].batch_category_id;
                    const currentModalityId = cart.items[index].modality_id;

                    for (let i = 0; i < index; i += 1) {
                      // só olha os anteriores
                      const ticket = tickets[i];
                      if (
                        ticket.document === currentDocument &&
                        ticket.item.batch_category_id === currentCategoryId &&
                        ticket.item.modality_id === currentModalityId
                      ) {
                        return context.createError({
                          message: `Este documento já foi usado para esta categoria e modalidade.`,
                        });
                      }
                    }

                    return true;
                  }
                )
                .test(
                  'no-duplicate-cpf-unique-ticket',
                  'Cada CPF só pode ser utilizado em 1 ingresso neste evento',
                  (_, context) => {
                    if (!isUniqueTicket) return true;

                    const currentDocument = context.parent[`document_${index}`];
                    if (!currentDocument) return true;

                    for (let i = 0; i < tickets.length; i += 1) {
                      if (i !== index) {
                        const otherDocument = context.parent[`document_${i}`];
                        if (
                          otherDocument &&
                          otherDocument === currentDocument
                        ) {
                          return context.createError({
                            message:
                              'Este CPF já está sendo utilizado em outro ingresso neste pedido. Cada CPF só pode ser usado em 1 ingresso neste evento.',
                          });
                        }
                      }
                    }

                    return true;
                  }
                ),
              [`name_${index}`]: Yup.string().test(
                'full-name',
                'Informe nome e sobrenome',
                (value) => {
                  if (!value) return false;

                  const parts = value.trim().split(/\s+/).filter(Boolean);

                  return parts.length >= 2;
                }
              ),
              [`birthdate_${index}`]: Yup.string()
                .test(
                  'check_birthdate',
                  'A data de nascimento é obrigatória',
                  () => !!data[`birthdate_${index}` as keyof IFormData]
                )
                .test('check_age_restrictions', '', (value, context) => {
                  const birthdateValue =
                    data[`birthdate_${index}` as keyof IFormData];
                  const age = calculateAge(birthdateValue, eventDate);

                  if (item.has_age_group) {
                    const belowMin =
                      item.min_age !== undefined &&
                      (age === null || age < item.min_age);
                    const aboveMax =
                      item.max_age !== undefined &&
                      (age === null || age > item.max_age);

                    if (belowMin || aboveMax) {
                      let message =
                        'Esta categoria não permite a idade informada na data do evento';

                      if (
                        item.min_age !== undefined &&
                        item.max_age !== undefined
                      ) {
                        message = `Esta categoria é exclusiva para pessoas de ${item.min_age} até ${item.max_age} anos na data do evento`;
                      } else if (item.min_age !== undefined) {
                        message = `Esta categoria é exclusiva para pessoas a partir de ${item.min_age} anos na data do evento`;
                      } else if (item.max_age !== undefined) {
                        message = `Esta categoria é exclusiva para pessoas com até ${item.max_age} anos na data do evento`;
                      }

                      return context.createError({ message });
                    }

                    return true;
                  }

                  if (item.is_child && item.is_elderly) {
                    const childMaxAge = item.max_age ?? 12;
                    const isElderlyValid = age !== null && age >= 60;
                    const isChildValid =
                      age !== null &&
                      (item.min_age === undefined || age >= item.min_age) &&
                      age <= childMaxAge;

                    if (!isElderlyValid && !isChildValid) {
                      const isTeen = childMaxAge > 12 && childMaxAge < 18;
                      const childNoun = isTeen ? 'adolescente' : 'criança';
                      const childText =
                        item.min_age !== undefined
                          ? `${childNoun}s de ${item.min_age} até ${childMaxAge} anos`
                          : `${childNoun} até ${childMaxAge} anos`;

                      return context.createError({
                        message: `Esta categoria é exclusiva para idoso 60+ ou ${childText} na data do evento`,
                      });
                    }

                    return true;
                  }

                  if (item.is_child) {
                    const maxAge = item.max_age ?? 12;
                    const isValid =
                      age !== null &&
                      (item.min_age === undefined || age >= item.min_age) &&
                      age <= maxAge;

                    if (!isValid) {
                      const isTeen = maxAge > 12 && maxAge < 18;
                      const childNoun = isTeen ? 'adolescente' : 'criança';
                      const message = item.min_age
                        ? `Esta categoria é exclusiva para ${childNoun}s de ${item.min_age} até ${maxAge} anos na data do evento`
                        : `Esta categoria é exclusiva para ${childNoun}s com até ${maxAge} anos na data do evento`;

                      return context.createError({ message });
                    }

                    return true;
                  }

                  if (item.is_elderly) {
                    if (age === null || age < 60) {
                      return context.createError({
                        message:
                          'Esta categoria é exclusiva para pessoas com 60 anos ou mais na data do evento',
                      });
                    }

                    return true;
                  }

                  return true;
                }),
              [`gender_${index}`]: Yup.string()
                .test(
                  'check_gender',
                  'O gênero é obrigatório',
                  () => !!data[`gender_${index}` as keyof IFormData]
                )
                .test(
                  'check_male',
                  'Esta categoria é exclusiva para o sexo masculino',
                  () => {
                    if (!item.is_male) return true;
                    return data[`gender_${index}` as keyof IFormData] === 'M';
                  }
                )
                .test(
                  'check_female',
                  'Esta categoria é exclusiva para o sexo feminino',
                  () => {
                    if (!item.is_female) return true;
                    return data[`gender_${index}` as keyof IFormData] === 'F';
                  }
                ),
              [`phone_${index}`]: Yup.string().test(
                'check_phone',
                'O telefone é obrigatório',
                () => {
                  return !!data[`phone_${index}` as keyof IFormData];
                }
              ),
              [`email_${index}`]: Yup.string().test(
                'check_email',
                'O e-mail é obrigatório',
                () => {
                  return !!data[`email_${index}` as keyof IFormData];
                }
              ),
              [`size_${index}`]: Yup.string().test(
                'check_size',
                'O tamanho é obrigatório',
                () => {
                  return item.has_kit && hasSizeVariation
                    ? !!data[`size_${index}` as keyof IFormData]
                    : true;
                }
              ),
              ...responseQuestions.data.reduce((subPrevious, question) => {
                if (question.required) {
                  if (question.question_type_id === 1) {
                    subPrevious[`answer-text-${question.id}-${index}`] =
                      Yup.string().when(`$checkText-${question.id}`, {
                        is: (checkText: boolean) => checkText,
                        then: Yup.string().required('A resposta é obrigatória'),
                        otherwise: Yup.string(),
                      });
                  }
                  if (question.question_type_id === 2) {
                    subPrevious[`answer-radio-${question.id}-${index}`] =
                      Yup.string().when(`$checkRadio-${question.id}`, {
                        is: (checkRadio: boolean) => checkRadio,
                        then: Yup.string().required('A resposta é obrigatória'),
                        otherwise: Yup.string(),
                      });
                  }
                  if (question.question_type_id === 3) {
                    subPrevious[`answer-multiple-${question.id}-${index}`] =
                      Yup.string().when(`$checkMultiple-${question.id}`, {
                        is: (checkMultiple: boolean) => checkMultiple,
                        then: Yup.string().required('A resposta é obrigatória'),
                        otherwise: Yup.string(),
                      });
                  }
                }

                return subPrevious;
              }, {} as { [key: string]: Yup.StringSchema<string | undefined, Record<string, any>, string | undefined> }),
            };
          }, {} as { [key: string]: any }),
        });

        await schema.validate(data, {
          abortEarly: false,
          context: {
            ...responseQuestions.data.reduce((previous, question) => {
              if (question.required) {
                if (question.question_type_id === 1) {
                  previous[`checkText-${question.id}`] = question.required;
                }
                if (question.question_type_id === 2) {
                  previous[`checkRadio-${question.id}`] = question.required;
                }
                if (question.question_type_id === 3) {
                  previous[`checkMultiple-${question.id}`] = question.required;
                }
              }

              return previous;
            }, {} as { [key: string]: boolean }),
          },
        });

        const items: IItem[] = [];

        let index = 0;

        for (const ticket of tickets) {
          const kitSelected = sizes.find(
            (size) =>
              size.id.toString() === data[`size_${index}` as keyof IFormData]
          );
          items.push({
            ...ticket.item,
            has_age_group: ticket.item.has_age_group,
            min_age: ticket.item.min_age,
            max_age: ticket.item.max_age,
            ticket: {
              id: new Date().getTime(),
              document: data[`document_${index}` as keyof IFormData],
              name: data[`name_${index}` as keyof IFormData],
              phone: data[`phone_${index}` as keyof IFormData],
              email: data[`email_${index}` as keyof IFormData],
              birthdate: data[`birthdate_${index}` as keyof IFormData],
              gender: data[`gender_${index}` as keyof IFormData],
              answers: ticket.answers,
              kit:
                ticket.item.has_kit && kitId
                  ? {
                      id: kitId,
                      stock_control: kitStockControl,
                      quantity_id: data[`size_${index}` as keyof IFormData]
                        ? parseInt(data[`size_${index}` as keyof IFormData], 10)
                        : undefined,
                      size: kitSelected?.value,
                    }
                  : undefined,
            },
          });

          index += 1;
        }

        handleChangeItems(items);

        history.push(
          `${process.env.PUBLIC_URL}/eventos/${params.slug}/resumo${
            isPreview ? '/visualizacao' : ''
          }`
        );

        setSending(false);
      } catch (error) {
        setSending(false);
        const err = error as any;
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);

          const newTicketErrors: Record<number, string> = {};

          Object.keys(errors).forEach((key) => {
            const match = key.match(/_?(\d+)$/);
            if (!match) return;
            const index = parseInt(match[1], 10);
            if (!tickets[index]?.myTicket) return;
            if (newTicketErrors[index]) return;
            newTicketErrors[index] = errors[key];
          });

          setTicketErrors(newTicketErrors);
          formRef.current?.setErrors(errors);
        } else if (err.message === 'ingresso repetido') {
          setTicketError(
            data.document === user.additionalInformation.document
              ? 'Você já possui um ingresso para este evento'
              : 'Já existe um ingresso com este CPF para este evento'
          );
        } else {
          Swal.fire(
            'Oops...',
            'Ocorreu um erro tente novamente, por favor',
            'error'
          );
        }
      }
    },
    [
      cart.items,
      eventDate,
      eventId,
      handleChangeItems,
      hasSizeVariation,
      history,
      isPreview,
      isUniqueTicket,
      kitId,
      kitStockControl,
      params.slug,
      sizes,
      tickets,
      user.additionalInformation.document,
    ]
  );

  return (
    <Container banner={banner}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-11 text-center pt-3">
            <div className="d-flex justify-content-between">
              <ButtonBack className="btn-back" />
              <ButtonHome />
            </div>
            <div className="banner my-3" />
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h2 className="h4 mb-0 d-flex align-items-center">
                <KrUserDocument
                  color="#FF6900"
                  size={20}
                  className="me-2 signin-icon"
                />
                Titularidade
              </h2>
            </div>
            <h4 className="text-start mb-3">
              Para seguir para o pagamento por favor preencha os dados dos
              ingressos
            </h4>
          </div>

          <div className="col-11">
            <Form
              ref={formRef}
              onSubmit={handleSubmit}
              className="d-flex flex-column pb-3"
            >
              {tickets.map((ticket) => (
                <Ticket
                  ticket={{ ...ticket, sizes: getSizesForTicket(ticket.index) }}
                  myTicketIndex={indexSel}
                  onChangeMyTicket={handleChangeMyTicket}
                  onChangeTicket={handleChangeTicket}
                  onChangeAnswers={(answers) => {
                    handleChangeAnswers(answers, ticket.index);
                  }}
                  onChangeSize={handleChangeSize}
                  eventId={eventId}
                  ticketError={ticketErrors[ticket.index]}
                />
              ))}
              <button
                type="submit"
                disabled={sending}
                className="btn btn-login h6 fw-normal py-2 mb-0"
              >
                Continuar
              </button>
            </Form>
          </div>
        </div>
      </div>
      <Loading active={sizesLoaded} text="Carregando..." />
    </Container>
  );
};

export default CheckoutOwnership;
